











import Vue from 'vue'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Tab<T = any> {
  label: string
  value: T
  icon?: string
}

interface Methods {
  handleSelectTab: (tab: Tab) => void
}

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  active: any
  tabs: Tab[]
}

export default Vue.extend<{}, Methods, {}, Props>({
  props: {
    active: {
      required: true,
    },
    tabs: {
      required: true,
    },
  },
  methods: {
    handleSelectTab(tab: Tab) {
      this.$emit('select', tab.value)
    },
  },
})
